import axios from 'axios';

import { isProduction } from '../config';


axios.defaults.baseURL = isProduction
  ? 'https://baoziswap.finance/api/v1'
  // : "https://baozi-swap-backend.herokuapp.com/api/v1";
  : "http://127.0.0.1:8000/api/v1";

export default axios;
